import { render, staticRenderFns } from "./ProblemUrgencyEdit.vue?vue&type=template&id=60e7b738&scoped=true"
import script from "./ProblemUrgencyEdit.vue?vue&type=script&lang=js"
export * from "./ProblemUrgencyEdit.vue?vue&type=script&lang=js"
import style0 from "./ProblemUrgencyEdit.vue?vue&type=style&index=0&id=60e7b738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7b738",
  null
  
)

export default component.exports